import { createAsyncThunk } from "@reduxjs/toolkit";
import type { NotificationCenterItem } from "types";
import { apiGet } from "utilities/api";
import { NOTIFICATION_CENTER_INDEX_FILE, SCOPES } from "utilities/constants/constants";

export const fetchNotificationCenterIndex = createAsyncThunk(
	"notificationCenter/fetchIndex",
	apiGet<NotificationCenterItem[] | string>(
		(authConfig) =>
			authConfig.DATA_LAKE_API_ENDPOINTS.GET_COMMON_NOTIFICATION_DATA(
				NOTIFICATION_CENTER_INDEX_FILE,
			),
		[SCOPES.DATA_LAKE_READ],
	),
);

export const fetchNotificationCenterItem = createAsyncThunk(
	"notificationCenter/fetchItem",
	apiGet<string>(
		(authConfig, { fileName }) =>
			authConfig.DATA_LAKE_API_ENDPOINTS.GET_COMMON_NOTIFICATION_DATA(fileName),
		[SCOPES.DATA_LAKE_READ],
	),
);
